import React from 'react'
import { Header2, Paragraph, Spaced } from '.'

type Props = {
  errorMessage: string
}

export const ErrorScreen: React.FC<Props> = ({ errorMessage }) => (
  <div>
    <Spaced bottom>
      <Header2>Ansatte kunne ikke vises</Header2>
      <Paragraph>
        Noget gik galt og ansatte kunne derfor ikke hentes.
        <br />
        <br />
        Fejlbesked: {errorMessage}
      </Paragraph>
    </Spaced>
  </div>
)
